import ClientAgent from '../clientAgent'

export default class LoggedInUser {
  /** @type {ClientAgent} */
  _ca = null
  /** @type {string | null} */
  _address = null
  /** @type {string | null} */
  _birthDate = null
  /** @type {Array<string>} */
  _defaultConnectors = null
  /** @type {string | null} */
  _defaultSubscription = null
  /** @type {string | null} */
  _email = null
  /** @type {string | null} */
  _fbId = null
  /** @type {string | null} */
  _gender = null
  /** @type {string | null} */
  _googleId = null
  /** @type {string | null} */
  _hisnaStevilka = null
  /** @type {string | null} */
  _name = null
  /** @type {string | null} */
  _phone = null
  /** @type {bool | null} */
  _phoneVerified = null
  /** @type {string | null} */
  _picture = null
  /** @type {bool | null} */
  _smsTokenLogin = null
  /** @type {string | null} */
  _taxNumber = null
  /** @type {string | null} */
  _username = null

  async loadLoggedInUserDetails () {
    /** @type {LoggedInUser} */
    let response = await this.ca.makeRequest('user/info', {})
    for (const prop in response) {
      if (this[prop] !== undefined) {
        this[prop] = response[prop]
      }
    }
  }

  get address () {
    return this._address
  }

  set address (value) {
    this._address = value
  }

  get birthDate () {
    return this._birthDate
  }

  set birthDate (value) {
    this._birthDate = value
  }

  get defaultConnectors () {
    return this._defaultConnectors
  }

  set defaultConnectors (value) {
    this._defaultConnectors = value
  }

  get defaultSubscription () {
    return this._defaultSubscription
  }

  set defaultSubscription (value) {
    this._defaultSubscription = value
  }

  get email () {
    return this._email
  }

  set email (value) {
    this._email = value
  }

  get fbId () {
    return this._fbId
  }

  set fbId (value) {
    this._fbId = value
  }

  get gender () {
    return this._gender
  }

  set gender (value) {
    this._gender = value
  }

  get googleId () {
    return this._googleId
  }

  set googleId (value) {
    this._googleId = value
  }

  get hisnaStevilka () {
    return this._hisnaStevilka
  }

  set hisnaStevilka (value) {
    this._hisnaStevilka = value
  }

  get name () {
    return this._name
  }

  set name (value) {
    this._name = value
  }

  get phone () {
    return this._phone
  }

  set phone (value) {
    this._phone = value
  }

  get phoneVerified () {
    return this._phoneVerified
  }

  set phoneVerified (value) {
    this._phoneVerified = value
  }

  get picture () {
    return this._picture
  }

  set picture (value) {
    this._picture = value
  }

  get smsTokenLogin () {
    return this._smsTokenLogin
  }

  set smsTokenLogin (value) {
    this._smsTokenLogin = value
  }

  get taxNumber () {
    return this._taxNumber
  }

  set taxNumber (value) {
    this._taxNumber = value
  }

  get username () {
    return this._username
  }

  set username (value) {
    this._username = value
  }

  get ca () {
    if (this._ca === null) {
      this._ca = new ClientAgent()
    }
    return this._ca
  }

  set ca (value) {
    this._ca = value
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/Common/LoggedInUser.js